export default {"src":"/aplikace/_next/static/media/aplikace_hp_icon_hisense.d25529e8.svg","height":15,"width":90,"blurWidth":0,"blurHeight":0};